import { render } from "./addWaterFootprintConfigurationModal.vue?vue&type=template&id=67e7e940&scoped=true&ts=true"
import script from "./addWaterFootprintConfigurationModal.vue?vue&type=script&lang=ts"
export * from "./addWaterFootprintConfigurationModal.vue?vue&type=script&lang=ts"

import "./addWaterFootprintConfigurationModal.vue?vue&type=style&index=0&id=67e7e940&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67e7e940"]])

export default __exports__